import i18n from '@/i18n';

export default [
  {
    text: i18n.t('enums.PrevisaoEntregaStatus.pendenteCliente'),
    value: "PendenteCliente",
  },
  {
    text: i18n.t('enums.PrevisaoEntregaStatus.pendenteKel'),
    value: "PendenteKel",
  },
  {
    text: i18n.t('enums.PrevisaoEntregaStatus.finalizado'),
    value: "Finalizado",
  },
];